export default __webpack_public_path__ + "929febe1ef7c64a6b10f373d235f9e3f.png";